<template>
  <div class="flex flex-col items-center min-h-screen pt-10">
    <div class="w-full max-w-4xl">
      <div class="flex items-center mb-6">
  <button @click="goBack" class="mr-2 flex items-center justify-center bg-white border border-gray-200 rounded-full w-10 h-10 custom-shadow">
    &#8592; <!-- Unicode символ стрелочки влево -->
  </button>
  <div class="relative flex-grow">
    <svg
      class="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      width="24"
      height="24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M21 21l-4.35-4.35m1.12-6.32a7 7 0 11-14 0 7 7 0 0114 0z"
      />
    </svg>
    <input
      v-model="directionName"
      type="text"
      placeholder="Поиск"
      class="w-full p-3 pl-12 text-lg border border-gray-300 rounded-full"
    />
  </div>
</div>
      <h1 class="text-2xl font-semibold mb-4" v-if="!UIStore.isPending && UIStore.professions">{{ UIStore.professions.direction.title }} \ ПРОФЕССИИ</h1>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4" v-if="!UIStore.isPending && UIStore.professions">
        <button
          v-for="profession in UIStore.professions.professions"
          :key="profession.title"
          class="flex items-start bg-white hover:shadow-hover border border-gray-200 rounded-xl p-4 custom-shadow" @click="goToCollegeListScreen(profession.id)">
          <img :src="profession.coverUrl" alt="" class="w-24 h-24 rounded-lg object-cover mr-4">
          <div class="text-left flex flex-col justify-between h-full">
          <div>
            <h2 class="text-xl font-semibold">{{ profession.title }}</h2>
          </div>
          <div>
            <p class="text-gray-500 text-sm">Учебных заведений: {{ profession.establishmentCount }}</p>
            <p class="flex-1 text-left text-sm text-gray-500">Номер программы: {{ profession.number }}</p>
          </div>
        </div>
        </button>
      </div>
      <div v-else>
        <div class="loader-container">
          <div role="status">
              <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
              </svg>
              <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script setup>

    import {professionsStore} from "@/store/professionsStore";
    import {onMounted, ref, watch} from "vue";
    import {useRoute, useRouter} from "vue-router"
    const route = useRoute()
    import router from "@/router";
    const routerr = useRouter();

    const directionName = ref(''); 

watch(directionName, (newValue) => {
  UIStore.getProfessions(route.params.id, newValue)
  // console.log(newValue); // Новый значение directionNamea
});

const goBack = () => {
  routerr.back();
};
  
  const UIStore = professionsStore()

    onMounted(() => {
      UIStore.getProfessions(route.params.id, directionName.value)
    });

    const goToCollegeListScreen = (idProfession) => {
      router.push({name: 'collegeslistProfession', params: {id: idProfession}})
    }

  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .custom-shadow {
    box-shadow: 0 4px 6px rgba(104, 92, 182, 0.2);
    border-radius: 16px; /* Скругляем углы еще больше */
  } 
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  .hover\:shadow-hover:hover {
      box-shadow: 0 4px 6px rgba(104, 92, 182, 0.5);
    }
  .loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh; /* Устанавливаем минимальную высоту контейнера */
  margin-top: 4vh; /* Отступ сверху в 40% */
}
  a { 
    color: #42b983;
  }
  </style>
  